const wowApp = require('angular').module('wowApp.auth');

// Services
wowApp.service('LoginService', ['$rootScope', '$q', '$window', 'SessionStorageWrapper', 'Restangular', '$state', '$stateParams', 'Settings', 'ShopperAnalyticsService', 'AnalyticsService', 'ShopperService', require('./login.service')]);

// Directives
wowApp.component('wowLoginPage', require('./login-page.component').loginPageComponentDefinition);
wowApp.component('wowLoginForm', require('./login-form.component').loginFormComponentDefinition);



// WEBPACK FOOTER //
// ./src/auth/login/index.js